import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";

import { brasilApi, ipifyApi, nextCargoApi } from "./apis";
import { persistedReducer } from "./rootReducer";
import { listenerMiddleware } from "./utils";

export const store = configureStore({
  devTools: import.meta.env.MODE !== "production",
  reducer: persistedReducer,
  middleware: (gdm) =>
    gdm({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
      .concat(nextCargoApi.middleware, brasilApi.middleware, ipifyApi.middleware)
      .prepend(listenerMiddleware.middleware)
});

export const persistor = persistStore(store);
setupListeners(store.dispatch);
